import React, { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

interface OwnProps {
  isProtected: () => boolean;
  redirectTo: string;
}

export const ProtectedRoute: FC<PropsWithChildren<OwnProps>> = (props) => {
  const { isProtected, redirectTo, children } = props;

  if (isProtected()) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return children;
};
